import { Col, Row, Space } from "antd";
import React, { useState } from "react";
import { Estados } from "./_Estados";
import { Clientes } from "./_Clientes";
import { Proveedores } from "./_Proveedores";
import { Concesionados } from "./_Concesionados";
import { Fechas } from "./_Fechas";
import { Submit } from "./_Submit";
import { useDispatch } from "react-redux";
import { startGetReportePorMes } from "../../../../context/actions/reportesActions";
import { useVerTodo } from "./useVerTodo";
import { Hide } from "./_Hide";

// mes = current mes

const mes = new Date().getMonth();
const anio = new Date().getFullYear();

export const Controles = () => {
  const dispatch = useDispatch();
  const [body, setBody] = useState({ mes, anio });

  const { handleVerTodo, canHide } = useVerTodo();

  const handleChange = (ele, val) => {
    setBody({ ...body, [ele]: val });
  };
  const submit = () => {
    dispatch(startGetReportePorMes(body));
  };

  return (
    <div style={{ marginBottom: 20 }}>
      {/* primera fila - 3 desplegables */}
      <Row gutter={[10, 10]} style={{ marginBottom: 10 }}>
        <Col xs={8} lg={8}>
          <Estados handleChange={handleChange} body={body} />
        </Col>
        <Col xs={8} lg={8}>
          <Clientes handleChange={handleChange} body={body} />
        </Col>
        <Col xs={8} lg={8}>
          <Proveedores handleChange={handleChange} body={body} />
        </Col>
      </Row>
      
      {/* segunda fila - 3 desplegables */}
      <Row gutter={[10, 10]} style={{ marginBottom: 10 }}>
        <Col xs={8} lg={8}>
          <Concesionados handleChange={handleChange} body={body} />
        </Col>
        <Col xs={16} lg={16}>
          <Fechas handleChange={handleChange} body={body} />
        </Col>
      </Row>
      
      {/* tercera fila - Botón centrado */}
      <Row gutter={[10, 10]} justify="center">
        <Col>
          <Space align="center">
            <Submit submit={submit} body={body} />
            {canHide && <Hide handleVerTodo={handleVerTodo} />}
          </Space>
        </Col>
      </Row>
    </div>
  );
};
